// extracted by mini-css-extract-plugin
export var container = "RelatedPosts-module--container--iQNCj";
export var postsWrapper = "RelatedPosts-module--postsWrapper--2d9HG";
export var postsList = "RelatedPosts-module--postsList--1pJ-O";
export var postTitle = "RelatedPosts-module--postTitle--2bxcJ";